<app-table [rows]="items" [columns]="columns">
    <ng-template #rowTemplate let-row>
        <tr>
            <td>{{row.Date | appDate:'datetime'}}</td>
            <td>{{row.Type}}</td>
            <td>{{row.Subject}}</td>
            <td>{{getMessage(row)}}</td>
            <td>
                <div class="table-actions">
                    <button type="button" class="btn btn-outline btn-icon" (click)="open(row)"
                            [ngbTooltip]="'open' | translate">
                        <i class="fi fi-rs-angle-right"></i>
                    </button>
                </div>
            </td>
        </tr>
    </ng-template>
</app-table>
